import { gatewayApiAgent } from 'common/api/apiAgents';
import { TaskCountsByStatus } from 'common/api-types/warehouse';

export const fetchTasksCount = (params: { warehouseId: string; createdAfter?: string }) =>
  gatewayApiAgent
    .get<TaskCountsByStatus>(`/warehouse/public/v1/task-counts`, {
      params,
    })
    .then((res) => res.data);
